<template>
  <div>
    <NotificationComponent></NotificationComponent>
  </div>
</template>
<script>
import NotificationComponent from './Notification/NotificationComponent';

export default {
  name: 'GlobalComponent',
  components: { NotificationComponent },
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted() {
  }
};
</script>
